module.exports = __webpack_public_path__ + "img/list-pattern3.4622dc3.svg";